export const LOOKING_FOR_MAX_LEN = 200;

export const LOOKING_FOR_SUGGESTIONS = [
  { label: "Tool evaluation", text: "Evaluating tools & platforms" },
  { label: "Architecture chat", text: "Architecture & platform design chats" },
  { label: "Real-time / streaming", text: "Real-time & streaming systems" },
  { label: "Lakehouse / warehouse", text: "Lakehouse & warehousing" },
  { label: "Sponsors / vendors", text: "Meeting sponsors & vendors" },
  { label: "Co-builders", text: "Collaborators for side projects" },
] as const;

function lookingForParts(current: string): string[] {
  return current
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

export function lookingForHasPhrase(current: string, phrase: string): boolean {
  const needle = phrase.trim().toLowerCase();
  return lookingForParts(current).some((part) => part.toLowerCase() === needle);
}

export function toggleLookingForSuggestion(current: string, phrase: string): string {
  const parts = lookingForParts(current);
  const needle = phrase.trim().toLowerCase();
  const idx = parts.findIndex((part) => part.toLowerCase() === needle);
  if (idx >= 0) {
    parts.splice(idx, 1);
    return parts.join(", ");
  }
  const next = parts.length ? `${parts.join(", ")}, ${phrase}` : phrase;
  return next.length > LOOKING_FOR_MAX_LEN ? current : next;
}
